import React, { useEffect, useState } from "react";

import styled from "styled-components";

import cookie from "./TEMPLATE/assets/icons/cookie.svg";

const CookieConsent = ({ setEnforceGA4 }) => {
  const [showBanner, setShowBanner] = useState(true);
  const [analyticsConsent, setAnalyticsConsent] = useState(false);

  // const accept = () => {
  //   localStorage.setItem("ga_consent", "granted");

  //   if (window.gtag) {
  //     window.gtag("consent", "update", {
  //       analytics_storage: "granted",
  //     });
  //   }

  //   window.dataLayer = window.dataLayer || [];
  //   window.dataLayer.push({
  //     event: "gtm.consent_granted",
  //   });

  //   // Force GA to send a pageview when consent is granted
  //   window.dataLayer.push({
  //     event: "page_view",
  //     page_path: window.location.pathname,
  //     page_title: document.title,
  //   });
  // };

  // const decline = () => {
  //   localStorage.setItem("ga_consent", "denied");

  //   if (window.gtag) {
  //     window.gtag("consent", "update", {
  //       analytics_storage: "denied",
  //     });
  //   }

  //   window.dataLayer = window.dataLayer || [];
  //   window.dataLayer.push({
  //     event: "gtm.consent_denied",
  //   });
  // };

  // useEffect(() => {
  //   const saved = localStorage.getItem("ga_consent");
  //   if (saved) setShowBanner(false);
  //   if (saved === "granted") accept();
  //   if (saved === "denied") decline();
  // }, []);

  return (
    <CookiesWidget $show={showBanner} style={{}}>
      <CookieIcon src={cookie} alt="cookie icon" width={300} />
      <CookieText>
        <h3>Ρυθμίσεις Cookies</h3>
        <p>
          Μπορείτε να επιλέξετε ποιες κατηγορίες cookies επιθυμείτε να
          επιτρέψετε. Ορισμένα cookies είναι απαραίτητα για τη σωστή λειτουργία
          του ιστότοπου και δεν μπορούν να απενεργοποιηθούν. Άλλα cookies μάς
          βοηθούν να βελτιώνουμε τις υπηρεσίες μας, να αναλύουμε την
          επισκεψιμότητα και να σας προσφέρουμε πιο σχετικό περιεχόμενο.
        </p>
        <p>
          Παρακάτω μπορείτε να διαχειριστείτε τις προτιμήσεις σας. Οι επιλογές
          σας θα αποθηκευτούν και μπορείτε να τις αλλάξετε οποιαδήποτε στιγμή
          μέσω της Πολιτικής Cookies.
        </p>
      </CookieText>
      <Divider />

      <ActionRow>
        <p style={{ fontWeight: "400", fontSize: "16px" }}>Αναγκαία</p>
        <ToggleButton $color="#8BC2A5" $isGranted={true} $canToggle={false}>
          <Dot $isGranted={true} />
        </ToggleButton>
      </ActionRow>
      <ActionRow>
        <p style={{ fonWeight: "400", fontSize: "16px" }}>
          Απόδοσης & Στατιστικών
        </p>
        <ToggleButton
          $color="#34C759"
          $isGranted={analyticsConsent}
          onClick={() => setAnalyticsConsent(!analyticsConsent)}
          $canToggle={true}
        >
          <Dot $isGranted={analyticsConsent} />
        </ToggleButton>
      </ActionRow>

      <ButtonsWrapper>
        <ActionButton
          onClick={() => {
            if (analyticsConsent) {
              setEnforceGA4(true);
            } else {
              setEnforceGA4(false);
            }
            setShowBanner(false);
          }}
        >
          Αποδοχή Επιλεγμένων
        </ActionButton>
        <ActionButton
          onClick={() => {
            setEnforceGA4(true);
            setShowBanner(false);
          }}
        >
          Αποδοχή Όλων
        </ActionButton>
      </ButtonsWrapper>
    </CookiesWidget>
  );
};

export default CookieConsent;

const CookiesWidget = styled.div`
  position: absolute;
  width: 500px;
  padding: 20px;
  bottom: 10px;
  right: ${({ $show }) => ($show ? "20px" : "-610px")};
  background-color: #1a1e24;
  color: white;
  opacity: ${({ $show }) => ($show ? "1" : "0")};
  border-radius: 10px;
  border: 2px solid white;
  display: flex;
  flex-direction: column;
  gap: 10px;
  transition: right 0.4s ease-in-out, opacity 0.4s ease-in-out;
  transition-delay: 0.5s, 0.1s;
  overflow: hidden;

  @media only screen and (max-width: 680px) {
    width: 380px;
  }
`;

const Divider = styled.div`
  width: 100%;
  height: 1px;
  background-color: #ffffff6f;
  margin-block: 4px;
`;

const CookieText = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  font-weight: 400;
  font-size: 14px;
`;

const ToggleButton = styled.div`
  position: relative;
  width: 50px;
  height: 30px;
  background-color: ${({ $color, $isGranted }) =>
    $isGranted ? $color : "#0000006A"};
  border-radius: 50px;
  display: flex;
  align-items: center;
  border-bottom: 1px solid #d0d0d080;
  cursor: ${({ $canToggle }) => ($canToggle ? "pointer" : "not-allowed")};
  transition: all 0.3s ease-in-out;
`;

const Dot = styled.div`
  width: 24px;
  height: 24px;
  background-color: white;
  border-radius: 50%;
  position: absolute;
  top: 3px;
  // left: 4px;
  box-shadow: ${({ $isGranted }) => ($isGranted ? "-4px" : "4px")} 0 4px
    rgba(0, 0, 0, 0.1);
  transform: ${({ $isGranted }) =>
    $isGranted ? "translateX(22px)" : "translateX(4px)"};
  transition: all 0.3s ease-in-out;
`;

const ActionRow = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;

const ActionButton = styled.button`
  background-color: #fff;
  color: #1a1e24;
  border-radius: 4px;
  padding: 10px 16px;
`;

const ButtonsWrapper = styled.div`
  display: flex;
  flex-direction: row;
  gap: 16px;
  align-items: center;
  margin-top: 14px;
`;

const CookieIcon = styled.img`
  position: absolute;
  opacity: 1;
  right: -10px;
  top: -14px;
`;
